export default __webpack_public_path__ + "static/media/load.aae0ac05.png";